// import attachEnterAsClick from 'utils/attachEnterAsClick';

import $ from 'jquery';
import scrollTo from 'utils/scroll-to';
import Inputmask from 'inputmask';
import {
    isValidDropdown, isValidText, isValidEmail, isValidPhone,
    isValidPostcode, isValidNumber, isValidCreditCardName, isValidCcNumber,
    isValidCvc, isValidCheckbox, isValidExpiryDate, isValidAccountName, isValidBsb
} from '../../components/form-elements/validation';
import initOrganisationField from '../../components/form-elements/c-organisation';
import paymentProcessingScene from '../../js/utils/payment-processing-scene';
import initAddressSearch from '../../components/form-elements/google-places';

/* eslint no-plusplus: [2, { allowForLoopAfterthoughts: true }] */
/* eslint no-underscore-dangle: 0 */
/* eslint quote-props: ["error", "consistent"] */

window.dataLayer = window.dataLayer || [];

const formName = ['amount', 'profile', 'payment'];
window.jQuery = $; // for BED/Kentico script

// helper function is a function that call by other function, not an initial function

/* helper: validate form intro, custom form validation and toggle next buton error
* dont put binding here, it called multiple time
* update ammount message on payment form
*/
const isValidIntro = () => {
    const $form = $('.s-donation-form-multi-step.intro.stc-form');
    if ($form.length === 0) return true;

    const minAmount = $form.find('.js-donate').data('min-donate');
    const maxAmount = $form.find('.js-donate').data('max-donate');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $donateState = $form.find('.donate-frequency .donate-option, .donate-amounts .donate-option, .donate-amount-input input');
    const $donateAmountField = $form
        .find(`.js-donate .donate-option[data-amount='${$donateAmount.val()}'][data-freq-mode='${$donateFreq.val()}']`);
    const $message = $form.find('.donate-msg .donate-message-selected');
    const $errorCon = $form.find('.donate-error');
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const $donateMonthlyFreq = $form.find('.donate-monthly-btn:not(.monthly-text-off)');
    const donateFreqvalue = $donateFreq.val().toLowerCase();
    const donateMonthlyFreqValue = $form.find('.donate-monthly-btn').length ? $form.find('.donate-monthly-btn').data('freq').toLowerCase() : 'no-monthly';
    let message = '';
    let errorMessage = '';

    // clear all selection state and message/error
    $donateState.removeClass('selected');
    $message.parent().removeClass('has-msg');
    $errorCon.removeClass('has-error');
    $buttonWraper.removeClass('Error');

    // freq
    $(`.js-donate .donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');

    if (donateFreqvalue === donateMonthlyFreqValue) {
        $donateMonthlyFreq.slideUp();
    } else {
        $donateMonthlyFreq.slideDown();
    }

    // if no freq selected, show error
    if ($donateFreq.val() === '') {
        errorMessage = $errorCon.data('error-donation-frequency-not-selected');
    }

    // amount
    if ($donateAmount.val() === '') {
        errorMessage = $errorCon.data('error-amount-missing');
    } else if ($donateAmountField.length > 0) {
        $donateAmountField.addClass('selected');
        message = $donateAmountField.data('message');
    } else {
        if ($donateAmount.val() !== '') {
            $form.find('.donate-amount-input input').addClass('selected');
        }

        if (minAmount <= $donateAmount.val() && maxAmount >= $donateAmount.val()) {
            message = '';
        } else {
            if ($donateAmount.val() > maxAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-max-amount') + maxAmount);
            }

            if ($donateAmount.val() < minAmount) {
                if (errorMessage !== '') errorMessage += '<br />';
                errorMessage += ($errorCon.data('error-min-amount') + minAmount);
            }
        }
    }

    // emptying message
    $message.html('');

    // render message
    if (message !== '') {
        $message.html(`$${$donateAmount.val()} ${message}`).parent().addClass('has-msg');
    }

    // render errorMessage
    if (errorMessage !== '') $errorCon.addClass('has-error').html(errorMessage);

    // return true or show error
    if (errorMessage === '') return true;
    $buttonWraper.addClass('Error');
    return false;
};

// helper: personal form field type and validation function
const personalFieldTypes = () => [
    {
        type: 'dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'email',
        tag: 'input',
        func: isValidEmail
    },
    {
        type: 'phone',
        tag: 'input',
        func: isValidPhone
    },
    {
        type: 'postcode',
        tag: 'input',
        func: isValidPostcode
    },
    {
        type: 'text-other',
        tag: 'input',
        func: isValidText
    }
];

// helper: payment form field type and validation function
const paymentFieldTypes = () => [
    {
        type: 'text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'cardname',
        tag: 'input',
        func: isValidCreditCardName
    },
    {
        type: 'number',
        tag: 'input',
        func: isValidNumber
    },
    {
        type: 'ccNumber',
        tag: 'input',
        func: isValidCcNumber
    },
    {
        type: 'expiry',
        tag: 'input',
        func: isValidExpiryDate
    },
    {
        type: 'cvc',
        tag: 'input',
        func: isValidCvc
    },
    {
        type: 'accountName',
        tag: 'input',
        func: isValidAccountName
    },
    {
        type: 'bsb',
        tag: 'input',
        func: isValidBsb
    },
    {
        type: 'checkbox',
        tag: 'input',
        func: isValidCheckbox
    },
    {
        type: 'dropdown',
        tag: 'select',
        func: isValidDropdown
    }
];

// helper: payment form field type and validation function
const AddressFieldWithAutocompleteTypes = () => [
    {
        type: 'g-autocomplete-text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'g-autocomplete-dropdown',
        tag: 'select',
        func: isValidDropdown
    },
    {
        type: 'g-autocomplete-postcode',
        tag: 'input',
        func: isValidPostcode
    }
];

/* helper: validate all field in personal/payment detail form
* don't put binding here, it called multiple time
* use only when submit or check whole form, not for validate individual field
* mannualy loop and call each field type validation (import from validation.js)
* toggle next button error
*/
const isValidDetail = (type, fieldTypes, ignoreValidation) => {
    // debug function, set on validateForm();
    if (ignoreValidation === true) {
        /* eslint-disable no-console */
        console.log(`%c Debug mode: %c ${type} validation is ignored\nRemove param true on validateForm() s-donation-form-multi-step.js`, 'background: #ccc; color: #ff0000; font-weight: bold', 'background: #ff; color: #333; font-weight: 400');
        return true;
    }

    const $form = $(`.s-donation-form-multi-step.${type}-details.stc-form`);
    if ($form.length === 0) return true;

    let valid = true; // this is the only one who set it true, other will set to false
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const doValidate = (el, func) => {
        if (!func($(el))) valid = false; // make sure it only change to false
    };

    // clear button error
    $buttonWraper.removeClass('Error');

    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function') {
            $form.find(`.jsv-${fieldTypes[i].type} ${fieldTypes[i].tag}:visible`).not(`.hide ${fieldTypes[i].tag}`)
                .each((index, element) => doValidate(element, fieldTypes[i].func));
        }
    }


    // return true or show error
    if (valid) return true;

    // Not valid, add error class and scroll up to error field
    $buttonWraper.addClass('Error');
    scrollTo('.js-error', 100);
    return false;
};

/* helper: validate single input base on type
* validate on change
* validate on keyup if it already error
*/
const validateInputByType = ($form, type, validationFunction, callback) => {
    $form.find(`.jsv-${type} input`)
        .on('change', function () { // on change
            const isValid = validationFunction($(this), callback);

            if (type !== 'ccNumber' || (isValid && type === 'ccNumber')) {
                window.dataLayer.push({
                    'event': `${type.replaceAll('-', '_')}_input_change`,
                    'inputId': $(this).attr('id')
                });
            }
        })
        .keyup(function () { // on keyup only when it has error
            const $el = $(this);
            if ($el.closest('.EditingFormValueCell.js-error').length > 0) validationFunction($el, callback);
        });
};
/*
* helper: validate google autocomplete address detail fields
* toggle next button error
*/
const isValidAddressDetailWithAutocomplete = (ignoreValidation = false) => {
    // debug function, set on validateForm();
    if (ignoreValidation === true) {
        /* eslint-disable no-console */
        console.log('%c Debug mode: %c google autocomplete validation is ignored\nRemove param true on validateForm() in s-donation-form-multi-step.js', 'background: #ccc; color: #ff0000; font-weight: bold', 'background: #ff; color: #333; font-weight: 400');
        return true;
    }

    const $form = $('.personal-details.stc-form');
    if ($form.length === 0) return true;

    let valid = true; // this is the only one who set it true, other will set to false
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    // custom callback to toggle address details after form valildation failed.
    const addressCallback = () => {
        const $switchManualBtn = $('.js-search-address-manually a');
        if ($switchManualBtn.length) {
            $switchManualBtn.trigger('click');
        }
    };
    const doValidate = (el, func) => {
        if (!func($(el))) {
            valid = false; // make sure it only change to false
            addressCallback();
        }
    };

    // clear button error
    $buttonWraper.removeClass('Error');
    const fieldTypes = AddressFieldWithAutocompleteTypes();
    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function') {
            $form.find(`.jsv-${fieldTypes[i].type} ${fieldTypes[i].tag}:visible`)
                .each((index, element) => doValidate(element, fieldTypes[i].func));
        }
    }

    const streetNameEl = $form.find('.js-address-street input')[0];
    const streetName = (streetNameEl && streetNameEl.value.length > 0) ? streetNameEl.value : false;
    const postcodeEl = $form.find('.js-address-postcode input')[0];
    const postcode = (postcodeEl && postcodeEl.value) ? postcodeEl.value : false;

    if (!!streetName && !!postcode && streetName.includes(postcode)) {
        valid = false;
        $(streetNameEl).closest('.EditingFormValueCell').addClass('js-error invalid');
        addressCallback();
    }

    // return true or show error
    if (valid) return true;

    // Not valid, add error class and scroll up to error field
    $buttonWraper.addClass('Error');
    scrollTo('.js-error', 100);
    return false;
};

// helper: select which form to validate
// eslint-disable-next-line import/prefer-default-export
export const validateForm = index => {
    switch (index) {
        case 0:
            return isValidIntro();
        case 1:
            // return isValidDetail('personal', personalFieldTypes(), true); // this will skip validation with console notice
            if (isValidAddressDetailWithAutocomplete() && isValidDetail('personal', personalFieldTypes())) {
                return true;
            }
            return false;
        case 2:
            // return isValidDetail('payment', paymentFieldTypes(), true); // debuger
            return isValidDetail('payment', paymentFieldTypes());
        default:
            // Form index is not specified, then we simply pass form validation
            return true;
    }
};

// helper: navigate form by index
const navigateFormByIndex = (index, scrollTop = false) => {
    const $forms = $('.s-donation-form-multi-step.js-donation-form');
    const $stepNum = $('.donation-progress-container .step-label span');

    $stepNum.text(index + 1);

    if ($forms.length === 0) return;
    if ($($forms[index]).length === 0) return;

    const stepPercentage = ((index + 1) / $forms.length) * 100;

    // update progress bar and url hash
    $('.donation-progress-bar').css('width', `${stepPercentage}%`);
    document.location.hash = formName[index] || '';

    // hide all form and show current
    $forms.addClass('hide');
    $($forms[index]).removeClass('hide');

    // scroll to nav
    if (scrollTop) scrollTo('.s-donation-header');
};

// helper: walk the form and do validate
const formsWalker = (indexRequested, noScrollTop = false) => {
    const $forms = $('.s-donation-form-multi-step.js-donation-form');
    if ($forms.length === 0) return;

    // if form not exist, return
    const index = indexRequested < 0 ? 0 : indexRequested;
    if ($forms[index] === undefined) return;

    // update state loaded
    $('.js-donation-form').addClass('loaded');

    // loop form to get selected while do validation
    for (let i = 0; i <= index; i++) {
        navigateFormByIndex(i, !noScrollTop);

        // if error found, break; check only when it need to move to next form
        if (index > i) {
            if (!validateForm(i)) break;
        }
    }

    // scroll to nav
    if (noScrollTop) return;
    scrollTo('.progress-bar-container');
};

const updateAmountOnForm = value => {
    const $amountDesc = $('.donation-content.js-amount span');
    const $paymentBtn = $('.payment-details.stc-form .btn.js-amount');

    // update amount on profile and payment button
    if ($amountDesc.length > 0) {
        $amountDesc.text(value);
    }

    if ($paymentBtn.length > 0) {
        const $donateFreq = $('.donate-hidden-freq').val().toLowerCase();
        let submitBtnText;
        if ($donateFreq === 'single') {
            submitBtnText = $paymentBtn.data('single-donation-text');
        } else {
            submitBtnText = $paymentBtn.data('recurring-donation-text');
        }

        submitBtnText = submitBtnText.replace('[amount]', `$${value}`);

        // for submit buttons without icons
        $paymentBtn.val(submitBtnText);
        // for submit buttons with icons
        $paymentBtn.find('span').text(submitBtnText);
    }
};

// helper: use hidden fill to update form state
const initIntroForm = () => {
    const $form = $('.s-donation-form-multi-step.intro.stc-form');

    if ($form.length === 0) return;

    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $('.donate-hidden-amount');
    const $lastDonateAmount = $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`);

    const donateValue = $lastDonateAmount ? $lastDonateAmount : $donateAmount.val();

    const $donateAmountField = $(`.donate-option[data-amount='${donateValue}']`);
    const $recurringField = $('.recurring-field');

    if ($donateFreq.length <= 0) return;

    // window.globalHelper.orderSessionManager.init();
    window.globalHelper.orderSessionManager.setAppealDonationValues();

    $(`.donate-option[data-freq='${$donateFreq.val()}']`).addClass('selected');
    $('.donate-amounts .donate-option').hide();
    $(`.donate-amounts .donate-option[data-freq-mode='${$donateFreq.val()}']`).show();
    $recurringField.hide();

    if ($donateAmountField.length > 0) {
        $donateAmountField.addClass('selected');
    } else {
        $('.donate-amount-input input').val(donateValue).addClass('selected');
    }

    if ($donateFreq.val() === 'Recurring') {
        $recurringField.show();
    }

    updateAmountOnForm(donateValue);
};

// avoid kentico onclick button run before validate
export const removeKenticoOnclick = () => {
    const $button = $('.js-donation-form.payment-details .js-form-validate');
    if ($button.length === 0) return;

    if ($button.attr('onclick') !== undefined) {
        $button.addClass('js-click-to-submit');
        $button.removeAttr('onclick');
    }
};


// get processing fee amount based on payment type and amount
const getProcessingFee = () => {
    const $form = $('.s-donation-form-multi-step');
    const $processingFeeAmount = $form.find('#CheckBoxContro-processing-fee #processing-amount');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $paymentType = $('.hidden-payment-type');

    // call api if donation amount and payment type exists
    if ($donateAmount.val() && $paymentType.val()) {
        const $apiUrl = $form.find('#processing-fee-api').data('api-url');
        const paymentTypeQuery = {
            'paypal-payment': 'PayPal',
            'cc-form': 'CreditCard',
            'debit-form': 'DirectDebit'
        };
        const $queryUrl =
            `${$apiUrl}?amount=${$donateAmount.val()}&paymenttype=${paymentTypeQuery[$paymentType.val()]}`;

        fetch($queryUrl)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Request failed');
            })
            .then(jsonResponse => $processingFeeAmount.html(jsonResponse.data))
            .catch(err => {
                console.log(err);
            });
    }
};

// Toggle which payment method is shown
const togglePaymentMethodsOptions = () => {
    const $donateFreq = $('.donate-hidden-freq');
    const paypalOption = 'paypal-payment';
    const debitOption = 'debit-form';
    if ($donateFreq.val() === 'Single') {
        $(`.donate-option[data-form-id='${debitOption}']`).hide();
        $(`.donate-option[data-form-id='${paypalOption}']`).show();
        $('.paypal-icon').show();
        $('#RecurringPaymentDisclaimer').addClass('hide');
    } else if ($donateFreq.val() === 'Recurring') {
        $(`.donate-option[data-form-id='${debitOption}']`).show();
        $(`.donate-option[data-form-id='${paypalOption}']`).hide();
        $('.paypal-icon').hide();
        $('#RecurringPaymentDisclaimer').removeClass('hide');
    }
};

// show form base on request but limit to validation
const initCurrentForm = () => {
    const requestedFormIndex = formName.indexOf(window.location.hash.replace('#', ''));

    // make sure intro form is filled base on hidden field
    initIntroForm();

    // go to specific form include validation
    formsWalker(requestedFormIndex, requestedFormIndex <= 0);
};

const updateCheckboxLabels = item => {
    const $recurringField = $('.recurring-field');
    const $hiddenPaymentField = $('#hidPaymentType');
    if (item === 'Recurring') {
        $('.label-once').addClass('hidden');
        $('.label-processing-fee-once').addClass('hidden');
        $('.label-processing-fee-monthly').removeClass('hidden');
        if ($hiddenPaymentField.val() === 'cc-form') {
            $('.label-monthly-cc').removeClass('hidden');
            $('.label-monthly-dd').addClass('hidden');
            $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our T&C and privacy policy';
        } else {
            $('.label-monthly-dd').removeClass('hidden');
            $('.label-monthly-cc').addClass('hidden');
            $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our Direct Debit Services Agreement';
        }
        $recurringField.show();
    }
    if (item === 'Single') {
        $('.label-once').removeClass('hidden');
        $('.label-monthly-cc').addClass('hidden');
        $('.label-monthly-dd').addClass('hidden');
        $recurringField.hide();
        $('.checkbox-error-msg')[0].innerHTML = 'You must agree to our T&C and privacy policy';
        $('.label-processing-fee-once').removeClass('hidden');
        $('.label-processing-fee-monthly').addClass('hidden');
    }
};


/* intro form bind
* update payment form message - donate amount
*/
const initIntroFormUpdateAction = () => {
    const $form = $('.s-donation-form-multi-step.intro.stc-form');
    const $donateOptions = $form.find('.donate-frequency .donate-option, .donate-amounts .donate-option');
    const $donateCustom = $form.find('.donate-amount-input input');
    const $donateFreq = $form.find('.donate-hidden-freq');
    const $donateAmount = $form.find('.donate-hidden-amount');
    const $errorCon = $form.find('.donate-error');
    const $amoutOptions = $form.find('.donate-amounts .donate-option');
    const $preSelectedOptions = $form.find('.donate-amounts .donate-option.selected');
    const $message = $form.find('.donate-msg .donate-message-selected');
    const $iconHolder = $form.find('.donation-icon');

    if ($form.length <= 0) return;

    // Init form icon on pre-selected amount
    if ($preSelectedOptions.length) {
        $donateAmount.val($preSelectedOptions.data('amount')).trigger('change');
        $donateCustom.val('');
        getProcessingFee();
        togglePaymentMethodsOptions();

        // On amount selection, we also change the displaying icon
        if ($iconHolder.length && $preSelectedOptions.find('.amount-icon').length) {
            $iconHolder.html($preSelectedOptions.find('.amount-icon').html());
        }
    }

    // Attach Enter key to the donation form to make it trigger the next button
    $('.s-donation-form-multi-step.js-donation-form').on('keyup', function (e) {
        const event = e || window.event;
        const charCode = (typeof event.which === 'undefined') ? event.keyCode : event.which;

        // Press Next if the key is an enter
        if (charCode === 13) {
            $(this).find('.js-form-validate').trigger('click');
        }
    });

    // on donation freq change, show hide message/error
    $donateFreq.on('change', () => {
        isValidIntro();
        togglePaymentMethodsOptions();
    }).trigger('change');

    // on donation amount change, how hide message/error
    $donateAmount.on('change', () => {
        isValidIntro();
        getProcessingFee();
        // update amount on profile and payment button
        updateAmountOnForm($donateAmount.val());
    }).trigger('change');

    // on selection change, update donation
    $donateOptions.on('click', function (e) {
        e.preventDefault();
        const $el = $(this);

        if ($el.data('freq') !== undefined) {
            const freqValue = $el.data('freq').toLowerCase();
            $donateFreq.val($el.data('freq')).trigger('change');
            window.dataLayer.push({
                'event': 'donation_freq_input_change',
                'inputId': freqValue
            });
            // Show hide the donation amount options for the frequency selected
            $('.donate-amounts .donate-option').hide();
            $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).show();
            if (!$donateCustom.val()) {
                const lastFreqAmount = $donateFreq.data(`last-${freqValue}-amount`);
                // No custom donation value, then we set the 2nd donation amount options as selected by default
                if (lastFreqAmount) {
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).filter(`[data-amount="${lastFreqAmount}"]`).click();
                } else {
                    // No last stored frequency amount, so click the 2nd amount by default
                    $(`.donate-amounts .donate-option[data-freq-mode='${$el.data('freq')}']`).eq(1).trigger('click');
                }
            }
        }
        if ($el.data('amount') !== undefined) {
            window.dataLayer.push({
                'event': 'donation_amount_input_change',
                'inputId': `${$el.data('freq-mode').toLowerCase()}_${$el.data('amount')}`
            });
            $donateFreq.data(`last-${$donateFreq.val().toLowerCase()}-amount`, $el.data('amount'));
            $donateAmount.val($el.data('amount')).trigger('change');
            $donateCustom.val('');

            // On amount selection, we also change the displaying icon
            if ($iconHolder.length && $el.find('.amount-icon').length) {
                $iconHolder.html($el.find('.amount-icon').html());
            }
        }

        updateCheckboxLabels($el.data('freq'));
        // update amount on profile and payment button
        updateAmountOnForm($donateAmount.val());
    });

    // on keyup in custom donation, update donation
    $donateCustom.on('keyup', function () {
        $donateAmount.val($(this).val());

        // trigger change if error visible
        if ($errorCon.hasClass('has-error')) $donateAmount.trigger('change');

        // Check if we have a valid value in the input, if so, unselect the other options
        if ($(this).val()) {
            $amoutOptions.removeClass('selected');
            $message.html('').parent().removeClass('has-msg');

            // On amount entered, we also change the displaying icon
            if ($iconHolder.length && $(this).siblings('.amount-icon').length) {
                $iconHolder.html($(this).siblings('.amount-icon').html());
            }
        }
    });

    // on keyup in custom donation, update donation
    $donateCustom.on('change', function () {
        window.dataLayer.push({
            'event': 'custom_amount_input_change',
            'inputId': $(this).attr('id')
        });
        $donateAmount.val($(this).val()).trigger('change');
    });
};

// detail form field bind and validation
const initDetailFormUpdateAction = (type, fieldTypes) => {
    const $form = $(`.s-donation-form-multi-step.${type}-details.stc-form`);
    if ($form.length === 0) return;

    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const excludeLoopText = ['dropdown'];
    const toggleButtonError = respon => {
        $buttonWraper.addClass('Error');

        if (respon) {
            if ($(`.${type}-details.stc-form .js-error`).length === 0) $buttonWraper.removeClass('Error');
        }
    };

    const $dropdownFields = $form.find('.jsv-dropdown select, .jsv-g-autocomplete-dropdown select');
    const $autocompleteAddressFields = $form.find('.jsv-g-autocomplete.js-search-address-manually input');
    const $cardExpiryField = $form.find('.jsv-expiry input');

    // prevents duplicate listeners
    $dropdownFields.off();
    $autocompleteAddressFields.off();


    $autocompleteAddressFields.on('change', function () {
        window.dataLayer.push({
            'event': `${$(this).attr('type')}_input_change`,
            'inputId': $(this).attr('id')
        });
    });

    // validate single dropdown on change
    $dropdownFields.on('change', function () {
        isValidDropdown($(this), null, toggleButtonError);
        window.dataLayer.push({
            'event': 'dropdown_input_change',
            'inputId': $(this).attr('id')
        });
    });


    $cardExpiryField.on('change', function () {
        const date = $(this).val().split('/');
        const month = date[0];
        const year = date[1];

        $('.hidden-cc-expiry-month').val(month);
        $('.hidden-cc-expiry-year').val(year);
    });

    // validate input-* [text, phone, number, postcode, cvc, checkbox]
    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function' && excludeLoopText.indexOf(fieldTypes[i].type) < 0) {
            validateInputByType($form, fieldTypes[i].type, fieldTypes[i].func, toggleButtonError);
        }
    }
};

// init organisation field separately because it's dynamically added/removed
const initOrganisationUpdateAction = () => {
    const $orgInputWrap = $('.js-organisation-field');
    if ($orgInputWrap.length === 0) return;

    const $buttonWraper = $('.submit-button-wrapper .EditingFormButtonCell');
    const toggleButtonError = respon => {
        $buttonWraper.addClass('Error');

        if (respon) {
            if ($('.js-error').length === 0) $buttonWraper.removeClass('Error');
        }
    };
    $('.js-organisation-field input')
        .on('change', function () { // on change
            isValidText($(this), toggleButtonError);
            window.dataLayer.push({
                'event': `${$(this).attr('type')}_input_change`,
                'inputId': $(this).attr('id')
            });
        })
        .keyup(function () { // on keyup only when it has error
            const $el = $(this);
            if ($el.closest('.EditingFormValueCell.js-error').length > 0) isValidText($el, toggleButtonError);
        });
};

// input form field mask
const inputMaskInit = () => {
    // Mask CC, BSB and Expiry field
    const ccNumberSelector = 'jsv-ccNumber';
    const expiryDateSelector = 'jsv-expiry';
    const bsbNumberSelector = 'jsv-bsb';

    // make sure it run on donation page only
    if ($(`.${ccNumberSelector}`).length === 0) return;

    const $inputMaskCC = $(`.${ccNumberSelector} input`);
    const $inputMaskBSB = $(`.${bsbNumberSelector} input`);
    const $inputMaskExpiry = $(`.${expiryDateSelector} input`);
    const $ccType = $('.hidden-cc-type');
    // const dinersTxt = window.cardTypes !== undefined ? window.cardTypes.Diners : 'Diners';
    const amexTxt = window.cardTypes !== undefined ? window.cardTypes.Amex : 'Amex';
    const $ccNumberError = $($inputMaskCC).parents(`.${ccNumberSelector}`).find('.js-error');

    if (!$inputMaskCC.length && !$inputMaskBSB.length) { return; }

    // resetting error message (if any)
    if ($ccNumberError.length > 0) {
        $ccNumberError.removeClass('js-error invalid');
    }

    $($inputMaskCC).val('');

    // need to destroy Inputmask on IOS 9
    Inputmask.remove($inputMaskCC);

    const applyCCMasks = () => {
        // if ($ccType.val() === dinersTxt) {
        //     Inputmask({
        //         mask: '9999 999999 9999 99',
        //         placeholder: '',
        //         showMaskOnFocus: false
        //     }).mask($inputMaskCC);
        // } else
        if ($ccType.val() === amexTxt) {
            Inputmask({
                mask: '9999 999999 99999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputMaskCC);
        } else {
            Inputmask({
                mask: '9999 9999 9999 9999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputMaskCC);
        }
    };

    // Mask the Expiration Date
    Inputmask({
        regex: '(0[1-9]|1[0-2])/([0-9]{2})',
        placeholder: '',
        showMaskOnFocus: false
    }).mask($inputMaskExpiry);

    applyCCMasks();

    Inputmask({
        mask: '999-999',
        placeholder: '',
        showMaskOnFocus: false
    }).mask($inputMaskBSB);

    // remove and reapply mask whilst autofill complete CC details
    $(document).on('keydown', e => {
        // Undefined key on "keydown" means autofill is being used.
        if (typeof e.key === 'undefined') {
            Inputmask.remove($inputMaskCC);
        }
    });
    $(document).on('keyup', e => {
        // Re-initialise inputmask after autofill has done it's job
        if (typeof e.key === 'undefined') {
            applyCCMasks();
        }
    });
};

const getPaymentType = () => {
    const $option = $('.js-card-form-select .payment-type select');
    const currType = $option.find(':selected').data('form-id');
    return currType;
};

// Common function to handle submit button click on the donate form - it is used on normal
// js-form-validate button and also any button with recaptcha enabled
// Function made global so it can be used by the google recaptcha callback
window.handleDonateHeaderButtonClick = $button => {
    const $form = $('.s-donation-form-multi-step');
    if ($form.length === 0) return;

    const currentFormIndex = formName.indexOf(window.location.hash.replace('#', ''));
    navigateFormByIndex(currentFormIndex + 1, true);

    const currPaymentType = getPaymentType();
    if (currPaymentType !== 'cc-form') {
        if ($button.hasClass('js-click-to-submit')) {
            if (!$button.attr('disabled')) {
                $button.attr('disabled', true);
                $button.removeClass('js-click-to-submit');
                paymentProcessingScene();
                window.__doPostBack($button.attr('name'), 'Click');
            }
        } else {
            window.dataLayer.push({ 'event': 'next_step_button_click' });
        }
    }
};

// init on submit next button - only the ones without recaptcha enabled
const initSubmitButton = () => {
    const $form = $('.s-donation-form-multi-step');
    const $submit = $form.find('.js-form-validate').not('.with-recaptcha');
    if ($submit.length === 0) return;

    if (formName.length > 0) {
        $submit.on('click', e => {
            e.preventDefault();

            const $button = $(e.target);
            const currentFormIndex = formName.indexOf(window.location.hash.replace('#', ''));
            const currPaymentType = getPaymentType();
            if (currPaymentType !== 'cc-form' && validateForm(currentFormIndex)) {
                window.handleDonateHeaderButtonClick($button);
            }
        });
    }
};

// init on submit next button - the ones with recaptcha enabled
const initSubmitButtonWithRecaptcha = () => {
    const $form = $('.s-donation-form-multi-step');
    const $submit = $form.find('.js-form-validate.with-recaptcha');
    if ($submit.length === 0) return;

    if (formName.length > 0) {
        $submit.on('click', e => {
            e.preventDefault();

            const $button = $(e.target);
            const currentFormIndex = formName.indexOf(window.location.hash.replace('#', ''));
            const currPaymentType = getPaymentType();
            if (currPaymentType !== 'cc-form' && validateForm(currentFormIndex)) {
                const $hiddenToken = $button.siblings('.g-recaptcha-response');
                // we trigger the google recaptcha call for anti-bot measure
                // Only trigger the re-captcha if we havent got the google check token
                if ($hiddenToken.length && $hiddenToken.val()) {
                    window.submitRecaptchaDonationHeaderForm($hiddenToken.val());
                } else {
                    window.grecaptcha.execute();
                }
            }
        });
    }
};

// This global function will be called by Google Recaptcha once the recaptcha validation is done on the client side
window.submitRecaptchaDonationHeaderForm = token => {
    const $button = $('.js-form-validate.with-recaptcha');
    const $hiddenToken = $button.siblings('.g-recaptcha-response');
    $hiddenToken.val(token);

    const currPaymentType = getPaymentType();
    if (currPaymentType !== 'cc-form') {
        window.handleDonateHeaderButtonClick($button);
    }
};

const initNavigateBack = () => {
    const $backButton = $('.back-btn');

    $backButton.on('click', e => {
        e.preventDefault();

        const currentFormIndex = formName.indexOf(window.location.hash.replace('#', ''));
        navigateFormByIndex(currentFormIndex - 1, true);
    });
};

// select payment method
const donateSelectCardForm = () => {
    const $paymentType = $('.hidden-payment-type');
    const $option = $('.js-card-form-select .payment-type .donate-option');
    let $selectedOption = $(`.js-card-form-select .payment-type .donate-option[data-form-id='${$paymentType.val()}']`);
    const $paymentBtn = $('.payment-details.stc-form .btn.js-amount');
    const $hiddenPaymentField = $('#hidPaymentType');

    const ccType = '.cc-type';

    if ($option.length === 0) return;

    $selectedOption.addClass('selected');

    $('.js-card-form-option-item').addClass('hide');

    const setSelectedCardForm = () => {
        $(`#${$selectedOption.data('form-id')}`).removeClass('hide').siblings('.js-card-form-option-item').addClass('hide');
        $paymentType.val($selectedOption.data('form-id'));
        $hiddenPaymentField.val($selectedOption.data('form-id'));
        const $donateFreq = $('.donate-hidden-freq').val();
        updateCheckboxLabels($donateFreq);
    };

    $option.on('click', function (e) {
        $selectedOption.removeClass('selected');
        $selectedOption = $(`.js-card-form-select .payment-type .donate-option[data-form-id='${$(e.target).data('form-id')}']`);
        $selectedOption.addClass('selected');

        if ($(e.target).data('form-id') === 'cc-form') {
            $paymentBtn.removeClass('js-click-to-submit');
        } else {
            $paymentBtn.addClass('js-click-to-submit');
        }

        window.dataLayer.push({
            'event': 'payment_option_input_change',
            'inputId': $(this).data('form-id')
                .replaceAll('form', '')
                .replace(/-+$/, '')
                .replaceAll('-', '_')
        });

        setSelectedCardForm();
        getProcessingFee();

        if ($(e.target).parents(`${ccType}`).length) {
            inputMaskInit($(e.target));
        }

        if ($(e.target).data('form-id') === 'paypal-payment') {
            // for submit buttons without icons
            $paymentBtn.val(`${$paymentBtn.val()} With PayPal`);
            // for submit buttons with icons
            $paymentBtn.find('span').append(' With PayPal');
        } else {
            // for submit buttons without icons
            $paymentBtn.val($paymentBtn.val().replace(' With PayPal', ''));
            // for submit buttons with icons
            $paymentBtn.find('span').text($paymentBtn.find('span').text().replace(' With PayPal', ''));
        }
    });

    setSelectedCardForm();
};


// allow input type number to have maxlength
const initMaxLengthNumber = () => {
    const $numberInput = $('.stc-form input[type=number]');
    if (!$numberInput.length) { return; }

    $numberInput.on('keypress', e => {
        const $el = $(e.target);
        const max = $el.attr('maxlength');
        if (max === undefined || max === '') return true;
        if ($el.val().length >= max) return false;
        return true;
    });
};

// validate input to allow number only on keypress, include money (disallow leading zero)
const initNumberOnlyInput = () => {
    const regex = /^\d+$/;
    const $numberInput = $('.stc-form input[type=number]');
    let oldVal = '';

    if (!$numberInput.length) { return; }

    $numberInput.on('keypress', e => {
        const $el = $(e.target);
        const event = e || window.event;
        const charCode = (typeof event.which === 'undefined') ? event.keyCode : event.which;
        const charStr = String.fromCharCode(charCode);
        const val = $el.val().toLowerCase() + charStr.toLowerCase();

        // test digit
        if (regex.test(val)) {
            // test for money format, for intro form only
            if ($el.closest('.donate-amount-input').length > 0) {
                if (val.startsWith('0')) return false;
            }

            return true;
        }

        return false;
    });

    // for money (intro form only)
    $numberInput.on('keyup', e => {
        const $el = $(e.target);
        const newVal = $el.val();

        if ($el.closest('.donate-amount-input').length > 0) {
            if (newVal.startsWith('0')) {
                $el.val(oldVal);
                return;
            }

            oldVal = newVal;
        }
    });
};

const initCcInput = () => {
    const $ccIcons = $('.cc-input .payment-options');
    const $ccType = $('.hidden-cc-type');
    const $inputCC = $('.jsv-ccNumber input');

    // regex to detect card type as the user inputs card number
    const visaRegEx = /^4/;
    const mastercardRegEx = /^5[1-5]/;
    const amexpRegEx = /^3[47]/;
    // const dinersRegEx = /^3[0689]/;

    const visaTxt = window.cardTypes !== undefined ? window.cardTypes.Visa : 'Visa';
    const mastercardTxt = window.cardTypes !== undefined ? window.cardTypes.MasterCard : 'MasterCard';
    const amexTxt = window.cardTypes !== undefined ? window.cardTypes.Amex : 'Amex';
    // const dinersTxt = window.cardTypes !== undefined ? window.cardTypes.Diners : 'Diners';

    if ($ccType.length === 0) return;

    $inputCC.on('input', e => {
        // reset card type value
        $ccType.val('');

        const $el = $(e.target);
        const newVal = $el.val().trim();

        if (visaRegEx.test(newVal) && $ccType.val() !== visaTxt) $ccType.val(visaTxt);
        if (mastercardRegEx.test(newVal) && $ccType.val() !== mastercardTxt) $ccType.val(mastercardTxt);
        // if (dinersRegEx.test(newVal) && $ccType.val() !== dinersTxt) {
        //     $ccType.val(dinersTxt);

        //     // update input mask to match diners format
        //     Inputmask({
        //         mask: '9999 999999 9999 99',
        //         placeholder: '',
        //         showMaskOnFocus: false
        //     }).mask($inputCC);
        // } else
        if (amexpRegEx.test(newVal) && $ccType.val() !== amexTxt) {
            $ccType.val(amexTxt);

            // update input mask to match amex format
            Inputmask({
                mask: '9999 999999 99999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputCC);
        } else {
            Inputmask({
                mask: '9999 9999 9999 9999',
                placeholder: '',
                showMaskOnFocus: false
            }).mask($inputCC);
        }

        $ccIcons.find('img').each(function () {
            $(this).addClass('greyscale');
        });

        if ($ccType.val().length === 0) return;

        const $ccIcon = $ccIcons.find(`img[data-card-type=${$ccType.val()}]`);

        // highlight matching cc type
        $ccIcon.removeClass('greyscale');
        $inputCC.trigger('change');
    });
};

const initReferrerField = () => {
    const $referrerDropdown = $('.jsv-referrer select');
    const $otherText = $('.jsv-text-other');
    $otherText.slideUp();
    $referrerDropdown.on('change', function (e) {
        if (e.target.value.toLowerCase() === 'other') {
            $otherText.slideDown('fast');
        } else {
            $otherText.slideUp('fast');
        }

        window.dataLayer.push({
            'event': 'referrer_input_change',
            'inputId': $(this).attr('id')
        });
    });
};


// special for appeal donation because it use 1st form/intro with postback
const disableSubmitIfError = () => {
    if ($('.appeal-donation').length === 1) {
        // eslint-disable-next-line
        $('.appeal-donation .donate-button').on('click', function (e) {
            e.preventDefault();

            const dType = $('.donate-hidden-freq').val();
            const dAmt = $('.donate-hidden-amount').val();

            if (dType !== '' && dAmt !== '') {
                // eslint-disable-next-line
                sessionStorage.setItem('dType', Base64.encode(dType));
                // eslint-disable-next-line
                sessionStorage.setItem('dAmt', Base64.encode(dAmt));

                if ($('.donate-error.has-error').length > 0) return;

                // eslint-disable-next-line
                javascript: __doPostBack('DonateButton', 'Click');
            }
        });
    }
};

const checkUtm = () => {
    const currentUrl = window.location.toString();

    if (!currentUrl.match(/(?:utm_source|utm_campaign|utm_medium)/i)) {
        const hiddenInput = document.querySelector('input[type=hidden].referrer-url');

        if (hiddenInput) {
            hiddenInput.value = document.referrer;
        }
    }
};

$(() => {
    // const multiForm = document
    const $form = $('.s-donation-form-multi-step');
    // const $submit = $form.find('.payment-submit-btn.with-recaptcha');

    if ($form.length === 0) return;

    removeKenticoOnclick();
    // keep above first, it has mapping and collection init

    initCurrentForm(); // open requested/error form
    initIntroFormUpdateAction(); // on chage, click, keyup etc
    initDetailFormUpdateAction('personal', personalFieldTypes()); // on chage, click, keyup etc
    initDetailFormUpdateAction('payment', paymentFieldTypes()); // on chage, click, keyup etc
    initDetailFormUpdateAction('personal', AddressFieldWithAutocompleteTypes()); // on change, click, keyup etc
    initSubmitButton();
    initSubmitButtonWithRecaptcha();
    initNavigateBack();
    initMaxLengthNumber();
    initNumberOnlyInput();
    initCcInput();
    initReferrerField();
    donateSelectCardForm();
    inputMaskInit();
    disableSubmitIfError();
    initOrganisationField(initOrganisationUpdateAction);
    initAddressSearch();
    checkUtm();
});



// WEBPACK FOOTER //
// ./src/sections/donation-header/s-donation-form-multi-step.js